import axios from 'axios';
import { getApiUrl } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const api = axios.create();
const handleWorkspaceSessionExpired = () => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('companyStaffSession');
  } catch {
    /* ignore */
  }

  if (typeof window !== 'undefined') {
    const currentPath = `${window.location.pathname}${window.location.search || ''}`;
    if (currentPath !== '/login?reason=workspace-expired') {
      window.location.assign('/login?reason=workspace-expired');
    }
  }
};

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() };
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const code = error?.response?.data?.code;
    if (code === 'WORKSPACE_SESSION_EXPIRED') {
      handleWorkspaceSessionExpired();
    }
    return Promise.reject(error);
  }
);

const workspaceAPI = {
  join: (payload) => api.post(getApiUrl('/api/workspace/join'), payload),
  getInvitePreview: (code) => api.get(getApiUrl('/api/workspace/invite-preview'), { params: { code } }),
  getDashboard: () => api.get(getApiUrl('/api/workspace/dashboard')),
  getInviteCode: () => api.get(getApiUrl('/api/workspace/invite-code')),
  regenerateInviteCode: (payload = {}) => api.post(getApiUrl('/api/workspace/invite-code/regenerate'), payload),
  getStaffInviteLink: (email) =>
    api.get(getApiUrl('/api/workspace/staff/invite-link'), { params: email ? { email } : {} }),
  sendStaffInviteLink: (payload) => api.post(getApiUrl('/api/workspace/staff/send-invite-link'), payload),
  getStaff: () => api.get(getApiUrl('/api/workspace/staff')),
  inviteStaff: (payload) => api.post(getApiUrl('/api/workspace/staff/invite'), payload),
  updateStaff: (id, payload) => api.patch(getApiUrl(`/api/workspace/staff/${id}`), payload),
  getActivity: (params) => api.get(getApiUrl('/api/workspace/activity'), { params }),
  getProperties: () => api.get(getApiUrl('/api/workspace/properties')),
  getBookings: () => api.get(getApiUrl('/api/workspace/bookings')),
  updateBookingStatus: (id, status) =>
    api.patch(getApiUrl(`/api/workspace/bookings/${id}/status`), { status }),
  getAnalytics: () => api.get(getApiUrl('/api/workspace/analytics')),
  getNotifications: () => api.get(getApiUrl('/api/workspace/notifications')),
};

export default workspaceAPI;
